import React from "react";
import TextInput from "../../../core/form/TextInput";

let PartnerEmailField = () => {

    return <TextInput
        type='email'
        name='email'
        label='form.partner.email'
        required={true}
    />

}

export default PartnerEmailField